import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";

// Одно поле: Account ID бэкенд находит по токену сам (аккаунтный токен
// видит ровно один аккаунт). Лейбл латиницей — название поля Cloudflare.
export function makeStreamingSettingsSchema(t: TFunction): Schema {
  return {
    apiToken: {
      type: "password",
      label: t("streamingSettings.form.apiTokenLabel"),
      required: true,
      xs: 12,
      fullWidth: true,
    },
  };
}
